var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-PB"},[_c('iframe',{attrs:{"title":"Devoluciones","width":"100%","height":"100%","src":"https://app.powerbi.com/view?r=eyJrIjoiYTI5YTcxM2MtY2FhYS00Mzc2LWI4MTItMzFjMDc5NDRhYjAwIiwidCI6IjllMDQ0ZjE3LWM3M2MtNGU1ZC04NWViLTMyNDNlNTU1YjczOSIsImMiOjR9&pageName=ReportSection7cdb283cd09780dccd96","frameborder":"0","allowFullScreen":"true"}})])
}]

export { render, staticRenderFns }